import React, { FC } from 'react';
import { Box } from '@mantine/core';
import { useStyles } from './styles';
import { IRole } from '@/entities/admin-app/directories';
import { EllipsisTooltip } from '@components/EllipsisTooltip';

interface IRolesListProps {
  roles: IRole[] | null | undefined;
}

export const RolesList: FC<IRolesListProps> = ({ roles }) => {
  const { classes } = useStyles();

  if (!Array.isArray(roles)) {
    return null;
  }

  return (
    <Box className={classes.listGroup}>
      {roles?.slice(0, 5).map((role, index) => {
        return (
          <EllipsisTooltip
            key={index}
            data-text={role?.Name}
            className={classes.rounded}
            width={100}
          >
            {role?.Name}
          </EllipsisTooltip>
        );
      })}
    </Box>
  );
};
